module.exports = __webpack_public_path__ + "static/img/top-bgimg.d9c4676.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yueyang/top-bgimg.png
// module id = j3ca
// module chunks = 1